
import { Observable } from "rxjs";
import { Subscription } from "../models/subscription";
import { SubscriptionApiService } from "../subscription-api.service";
import { Injectable } from "@angular/core";
import { SubscriptionService } from "./subscription.service";
import { ESubscriptionType } from "../enum/e-subscription-type";
import { PackageApiService } from "../../packages/package-api.service";
import { UserService } from "src/app/services/user.service";
import { Package } from "../../packages/models/package";
import { ModalController, ToastController } from "@ionic/angular";
import { SubscriptionPlateform } from "../models/subscription-plateform";
import { ESubscriptionStatus } from "../enum/e-subscription-status";
import { PackageFactoryService } from "../../packages/services/package-factory.service";
import { EPackageType } from "../../packages/enum/e-package-type";
import { YesNoModalComponent } from "src/app/components/shared/modals/yes-no-modal/yes-no-modal.component";
import { Utils } from "src/app/helpers/Utils";
@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlateformService extends SubscriptionService {

  public revokeUserSubscriptionBypackage(selectedPackage: Package): Observable<boolean> {
    return this.injector.get(SubscriptionApiService).revokeUserSubscriptionBypackage("subscription_plateform", selectedPackage.id);
  }

  public getSubscriptions(discriminator: ESubscriptionType): Observable<Subscription[]> {
    return this.injector.get(SubscriptionApiService).getSubscriptions(discriminator);
  }
  public getSubscription(subscriptionId: number): Observable<Subscription> {
    return this.injector.get(SubscriptionApiService).getSubscription(subscriptionId);
  }

  public GetLastSubscriptionByPackage(packageId: number): Observable<Subscription> {
    return this.injector.get(SubscriptionApiService).GetLastSubscriptionByPackage("subscription_plateform", packageId);
  }

  public createSubscription(subscription: Subscription): Observable<Subscription> {
    throw new Error("Method not implemented.");
  }

  public deleteSubscription(subscription: Subscription): Observable<number> {
    return this.injector.get(SubscriptionApiService).deleteSubscription(subscription);
  }
  public editSubscription(subscription: Subscription): Observable<any> {
    return this.injector.get(SubscriptionApiService).editSubscription(subscription);
  }

  public getStripeSessionToCheckout(selectedPackage : Package): Observable<any> {

    return this.injector.get(SubscriptionApiService).createCheckoutSession(selectedPackage);

  }
}
  